/* eslint-disable @typescript-eslint/no-unused-vars */
import { observer } from "mobx-react-lite";
import React, { useMemo, useState } from "react";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/TCText/TCText";
import {
  PlayerCalculatedStats,
  PlayerStatsComparisonType,
} from "../../../apis/types";
import {
  useMatchDetailsStore,
  useMatchStatsStore,
} from "../../../stores/StoreContext";

type props = {};

export const ComparisonProgress: React.FC<props> = observer(() => {
  const matchStatsStore = useMatchStatsStore();
  const matchDetailsStore = useMatchDetailsStore();
  const comparisonStats =
    matchDetailsStore.currentComparisonTab === "pair"
      ? matchStatsStore.getTeamComparisonStats()
      : matchStatsStore.getPartnerComparisonStats();

  return (
    <div style={styles.container}>
      {comparisonStats.map((item, index) => (
        <div style={{ marginTop: index === 0 ? 0 : 24 }}>
          <ComparisonProgressItem
            key={item.title}
            team1={{
              percentage: item.player1.percentage,
              value: item.player1.value,
            }}
            team2={{
              percentage: item.player2.percentage,
              value: item.player2.value,
            }}
            title={item.title}
            showPercentage={item.showPercentage}
          />
        </div>
      ))}
    </div>
  );
});

type ComparisonProgressItemProps = {
  team1: PlayerCalculatedStats;
  team2: PlayerCalculatedStats;
  title: string;
  showPercentage?: boolean;
};

export const ComparisonProgressItem: React.FC<ComparisonProgressItemProps> = ({
  team1,
  team2,
  title,
  showPercentage,
}) => {
  const winnerTeam = useMemo(() => {
    if (team1.percentage > team2.percentage) {
      return 1;
    } else {
      return 2;
    }
  }, [team1, team2]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: 5,
        }}
      >
        <TCText
          style={styles.rangeText}
          value={
            showPercentage ? `${team1.percentage}%` : team1.value.toString()
          }
        />
        <TCText style={styles.labelText} value={title} />
        <TCText
          style={styles.rangeText}
          value={
            showPercentage ? `${team2.percentage}%` : team2.value.toString()
          }
        />
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ComparisonProgressBar
          inactiveBgColor={winnerTeam === 1 ? Colors.gold : Colors.darkBrown}
          activeColor={Colors.lightGreen}
          percent={`${100 - team1.percentage}%`}
          outerTopRightRadius={0}
          outerBottomRightRadius={0}
          width={"50%"}
        />
        <ComparisonProgressBar
          inactiveBgColor={Colors.lightGreen}
          activeColor={winnerTeam === 2 ? Colors.gold : Colors.darkBrown}
          percent={`${team2.percentage}%`}
          outerTopLeftRadius={0}
          outerBottomLeftRadius={0}
          width={"50%"}
        />
      </div>
    </div>
  );
};

type ComparisonProgressBarProps = {
  inactiveBgColor?: string;
  activeColor?: string;
  percent?: string;
  height?: number;
  outerTopLeftRadius?: number;
  outerTopRightRadius?: number;
  outerBottomLeftRadius?: number;
  outerBottomRightRadius?: number;
  width?: string;
  flex?: number;
};
const ComparisonProgressBar = ({
  inactiveBgColor = Colors.lightGreen,
  activeColor = Colors.darkBrown,
  percent = "0%",
  height = 6,
  outerTopLeftRadius = 5,
  outerTopRightRadius = 5,
  outerBottomLeftRadius = 5,
  outerBottomRightRadius = 5,
  width,
  flex,
}: ComparisonProgressBarProps) => {
  return (
    <div
      style={{
        width: width ?? "100%",
        backgroundColor: inactiveBgColor,
        height: height,
        overflow: "hidden",
        borderTopRightRadius: outerTopRightRadius,
        borderTopLeftRadius: outerTopLeftRadius,
        borderBottomLeftRadius: outerBottomLeftRadius,
        borderBottomRightRadius: outerBottomRightRadius,
      }}
    >
      <div
        style={{ width: percent, backgroundColor: activeColor, height: "100%" }}
      />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: Colors.green,
    borderRadius: 8,
    marginLeft: 30,
    marginRight: 30,
    paddingTop: 12,
    paddingBottom: 12,
    marginTop: 12,
    marginBottom: 12,
  },

  labelContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  rangeText: {
    fontSize: 12,
    fontWeight: "600",
    color: Colors.white,
  },
  labelText: {
    fontSize: 12,
    fontWeight: "400",
    color: Colors.lightGoldenWithOpacity,
  },
};
